import { Controller } from 'stimulus'

export default class extends Controller {
  static values = { url: String, fileType: String }

  printFile() {
    const WinPrint = window.open('', '_blank', 'left=0,top=0,toolbar=0,scrollbars=0,status=0')
    WinPrint.document.write(this.getScript())
    WinPrint.document.write(this.getTag())
    WinPrint.document.close()
  }

  getTag() {
    if (this.fileTypeValue === 'pdf') {
      return '<iframe id="i_frame" src="' + this.urlValue + '" width="100%" height="100%"/>'
    } else {
      return '<img src="' + this.urlValue + '" width="100%" height="100%"/>'
    }
  }

  getScript() {
    let script = '<script> '
    script += 'function printFunction() { window.focus(); window.print(); window.close();} '
    script += 'window.addEventListener("load", printFunction);'
    script += '</script>'
    return script
  }
}
